<template>
        <div class=''>

            <vue-form  :canvalidate="false" :name="'member-'+memberId" :fields="questions" @change="updateInfo">  
            </vue-form>

        </div>
</template>

<script>
import _ from 'lodash';
export default {
    data(){
        return {
            formstate: {},
            model:{},
            infos:{},
        }
    },
    created:function(){
    },

    props:{
        memberId:{
            // type: Number,
            default:0
        },
    },

    computed:{
        order:function(){
            return this.$store.getters['OrderStore/currentOrder']
        },
        member:function(){
            return this.$store.getters['PurchaseStore/memberByID'](this.memberId)
        },
        questions:function(){
            return _.map(this.member.questions, question =>{
                let questionForForm = {...question}
                // change labem and key to correct question format
                questionForForm.label = question.name+""; //+"" to create new string, not just ref it
                questionForForm.name = question.key
                questionForForm.value = _.get(this.member.infos,question.key,'')
                if(questionForForm.value === ''){
                    questionForForm.value = _.get(question,'default_value','')
                }
                if(question.type == 'boolean'){
                    questionForForm.value = questionForForm.value === true ? true : false;
                }
                if(question.type == 'multiselect'){
                    if(!_.isArray(questionForForm.value)){
                        questionForForm.value = _.isEmpty(questionForForm.value) ? [] : [String(questionForForm.value)];
                    }
                }
            
                if(this.memberSaved){
                    let discountsApplied = this.order.discountsApplied
                    
                    if(discountsApplied){
                        let discount = _.find(discountsApplied, d=> {
                            return d.rule[0]  == question.key
                        })

                        let savedValue =  _.get(this.memberSaved.infos,question.key,'')

                        if(discount && savedValue != ''){
                            // debugger;
                            let applyForFieldValue = PriceCalculator.ruleAppliesForValue(discount.rule, questionForForm, savedValue);
                            
                            if(applyForFieldValue){
                                questionForForm.disabled = true
                            }

                            // questionForForm.disabled = true
                        }
                    }
                }
                
                // questionForForm.disabled = true

                return questionForForm;  
            })
        
        }

    },
   
    methods: {
        updateInfo:function(values){
            this.infos = values;
            // this.$store.commit('OrderStore/updateMemberInfo',{ memberId:this.memberId, infos:values })
            this.$store.commit('PurchaseStore/updateMemberInfo',{ memberId:this.memberId, infos:values })
        }
    }

    

}
</script>

<style lang="stylus">

    .member{
        background:rgba(#17a2b8,0.1)
        padding: 2em 1em;
        border-radius 10px;
        }


</style>
